






























































































































import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { fmoney } from '@/common/money';
import { TbMember, TbOrderPad } from '@/http';
import dayjs from "dayjs";
import calculate from '@/common/util/calculate';
import Bus from '@/common/util/bus';
import { Toast } from 'vant';
@Component({
    components: {
    },
})
export default class payPanel extends Vue {
    public $refs: {
        barcode:HTMLFormElement;
    };
    show = false;;
    @Prop({
        type:Object,
        default:()=>{
            return{

            }
        }
    })
    orderInfo:any;


    fmoney = fmoney;

    /**计时器 */
    count = 120;
    interval=null;
    count2 = 300;
    interval2=null;

    /**扫完付款码后 */
    isPaying = false;

    /**取消-连点 */
    isCanceling=false;

    /**无效扫码 */
    warnScanVal='';
    warnScanShow=false;

    /**移动支付-关闭操作提醒 */
    ydPayCloseTipShow=false;

    /**支付方式名称 */
    get payName(){
        let str = "";
        switch (this.orderInfo.paymentMethod) {
            case 1:
                str = "会员卡"
                break;
            case 2:
                str = "现金支付"
                break;
            case 3:
                str = "微信"
                break;
            case 4:
                str = "支付宝"
                break;
            case 13:
                str = "线下微信"
                break;
            case 14:
                str = "线下支付宝"
                break;

            default:
                if((this.orderInfo.paymentMethod>4&&this.orderInfo.paymentMethod<12)||this.orderInfo.paymentMethod>14){
                    str = "组合支付"
                }
                break;
        }
        return str;
    }

    @Watch('isPaying')
    payingChange(val){
        if(val==true){
            this.interval2 = setInterval(async () => {
                this.count2--;
                // Toast(this.count2);
                if(this.count2<=0){
                    // clearInterval(this.interval2)
                    // Bus.$emit('payFalse','true');
                    this.closeFun();

                return;
            }
        }, 1000);
        }
    }
    created() {

    }

    mounted() {

    }

    beforeUnmount() {
          clearInterval(this.interval);
          clearInterval(this.interval2);
          this.interval = null;
          this.interval2 = null;
          Bus.$off('resultPayCode');
          Bus.$emit('isPaying',false);
      }

    showFun(){
        this.isPaying = false;
    //    clearInterval(this.interval)
    //    clearInterval(this.interval2)
        this.count = 120;
        this.count2 = 300;
        this.warnScanShow = false;
       if(!(this.orderInfo.paymentMethod==2||this.orderInfo.paymentMethod==1||this.orderInfo.paymentMethod==11||this.orderInfo.paymentMethod>12)){
        this.interval =setInterval(async () => {
            this.count --;
            if(this.count<=0){
               this.closeFunHand();
            }

        }, 1000);
        Bus.$emit('isPaying',true);
       }

       Bus.$on('resultPayCode',(val)=>{
        //微信付款码
        let req = /^1[0-6][0-9]{16}$/;
        //支付宝付款码
        let req2 = /^(?:2[5-9]|30)\d{14,22}$/;
        //扫描到无效条形码
        if(!req.test(val)&&!req2.test(val)){
            clearInterval(this.interval);
            this.warnScanVal = val;
            this.warnScanShow = true;
            return;
        }
        this.isPaying = true;
        // 停止120秒等待扫码倒计时，避免与支付中倒计时(interval2)并行
        clearInterval(this.interval);
        this.interval = null;
        (this.$parent as any).startPay(val);

       });
       this.show = true;
    }
    /**条码异常-确定，恢复扫码倒计时 */
    onWarnScanConfirm(){
        // 防御：创建新定时器前先清除旧的，避免叠加
        clearInterval(this.interval);
        this.interval = null;
        this.count = 120;
        this.interval = setInterval(async () => {
            this.count --;
            if(this.count<=0){
               this.closeFunHand();
            }
        }, 1000);
        this.warnScanShow = false;
    }
    /**移动支付-取消，弹二次确认 */
    	closeFunHand2(){
    	    this.ydPayCloseTipShow = true;
    	}
    	/**确定关闭-通知父组件停止轮询 */
    	onydPayClose(){
    	    this.ydPayCloseTipShow = false;
    	    this.closeFun();
    	    this.$emit('cancelPay');
    	}
    	/**再等等-仅关闭确认框 */
    	onydPayCloseWait(){
    	    this.ydPayCloseTipShow = false;
    	}
    async closeFun(){
        this.isPaying = false;
         clearInterval(this.interval)
         clearInterval(this.interval2)
         this.interval = null;
         this.interval2 = null;
          Bus.$emit('isPaying',false);
          this.warnScanShow = false;
           this.show = false;

    }
    async closeFunHand(){
        this.warnScanShow = false;
        if(this.isCanceling==true)return;
        this.isCanceling = true;
        try {
          await TbOrderPad.CancelPayV2({id:this.orderInfo.id})
          this.isPaying = false;
         clearInterval(this.interval)
         clearInterval(this.interval2)
         this.interval = null;
         this.interval2 = null;
          Bus.$emit('isPaying',false);
           this.show = false;
           setTimeout(()=>{
               this.isCanceling = false;
           },400)
        } catch (error) {
            this.isCanceling = false;
            this.closeFun();
        }
    }
    payFun(){
        this.$emit("payFun");
        this.closeFun();
    }



}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/payPanel.vue